// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"16c1fab8","593":"f3d78fb3","749":"785ea69f"}[chunkId] + ".chunk.css";
};